import Vue from 'vue'
import Vuex from 'vuex'

import mutations from './mutations/index.js'
import state from './state/state.js'

Vue.use(Vuex)

const store = new Vuex.Store({
  // 内存数据状态，UI可通过this.$store.state.* 获得数据
  state,
  //修改全局参数
  mutations
})

export default store
